import React, { FC, ReactNode } from "react";
import { Skeleton, Box } from "@mui/material";
import { isDarkTheme } from "../../utils";
import { WHITE } from "../../constants";
import styles from "./SkeletonRow.styles";
type SkeletonRowProps = {
  label: ReactNode;
  amount?: ReactNode;
  isLoading: boolean;
  style?: any;
};

const SkeletonRow: FC<SkeletonRowProps> = ({
  label,
  amount,
  isLoading,
  style = {},
}) => {
  return (
    <Box
      sx={{
        ...styles.container,
        ...style,
      }}
    >
      <Box>
        {isLoading ? (
          <Skeleton
            variant="text"
            width={100}
            height={20}
            sx={{ bgcolor: isDarkTheme() ? WHITE : null }}
          />
        ) : (
          label
        )}
      </Box>

      {amount && (
        <Box>
          {isLoading ? (
            <Skeleton
              variant="text"
              width={80}
              height={20}
              sx={{ bgcolor: isDarkTheme() ? WHITE : null }}
            />
          ) : (
            amount
          )}
        </Box>
      )}
    </Box>
  );
};

export default SkeletonRow;
